import {Button, ButtonProps} from '@mui/material';
import {alpha, styled} from '@mui/material/styles';
import {forwardRef} from 'react';

export type LegacyButtonColor = 'default' | NonNullable<ButtonProps['color']>;

export type LegacyButtonProps = Omit<ButtonProps, 'color'> & {
  color?: LegacyButtonColor;
};

const LegacyDefaultButton = styled(Button)(({theme}) => ({
  color: theme.palette.text.primary,
  borderColor: alpha(theme.palette.common.black, 0.23),
}));

const LegacyButton = forwardRef<HTMLButtonElement, LegacyButtonProps>(({color = 'default', ...buttonProps}, ref) =>
  color === 'default' ? (
    <LegacyDefaultButton ref={ref} color="inherit" {...buttonProps} />
  ) : (
    <Button ref={ref} color={color} {...buttonProps} />
  ),
);

LegacyButton.displayName = 'LegacyButton';

export default LegacyButton;
